import { CalendarDays, Star } from "lucide-react";
import { Reveal } from "./motion";
import BookNowBox from "./BookNowBox";
import { LODGIFY_BOOK_NOW_SNIPPET, DOMES } from "../config/site";

function RatingBadge({ dome }) {
  if (!dome) return null;
  return (
    <span
      className="inline-flex items-center gap-1.5 font-mono text-[0.56rem] uppercase tracking-widest2 text-lavglow shrink-0 whitespace-nowrap"
      data-testid={`rating-badge-${dome.id}`}
    >
      <Star size={11} className="fill-lavglow text-lavglow" />
      {dome.rating} · {dome.reviews} Airbnb reviews
    </span>
  );
}

export default function BookingSearch({ className = "" }) {
  if (!LODGIFY_BOOK_NOW_SNIPPET) return null;
  return (
    <div className={`px-6 md:px-16 ${className}`} data-testid="booking-search-embed">
      <Reveal y={24}>
        <div className="max-w-3xl mx-auto">
          <div className="flex flex-wrap items-center gap-3 mb-5 px-1">
            <CalendarDays size={16} className="text-lavglow shrink-0" />
            <p className="font-mono text-[0.62rem] uppercase tracking-widest2 text-lavglow">
              Check availability & book
            </p>
          </div>
          <div className="space-y-6">
            <div>
              <div className="flex items-center justify-between gap-3 mb-2">
                <p className="font-mono text-[0.58rem] uppercase tracking-widest2 text-fern">Dome 01 · Piwakawaka</p>
                <RatingBadge dome={DOMES.find((d) => d.id === "piwakawaka")} />
              </div>
              <BookNowBox rental="piwakawaka" />
            </div>
            <div>
              <div className="flex items-center justify-between gap-3 mb-2">
                <p className="font-mono text-[0.58rem] uppercase tracking-widest2 text-fern">Dome 02 · Kārearea</p>
                <RatingBadge dome={DOMES.find((d) => d.id === "karearea")} />
              </div>
              <BookNowBox rental="karearea" />
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  );
}
